import api from "./api";

// Energy Breakdown and Energy Flow both read /energy-hierarchy-tree with the
// same params. The API always returns the whole facility (the selected branch
// is cut out in the browser), so one response per user + range serves both
// charts and every branch. Kept for the session, like the Historical cards and
// chart; a failed request is dropped so a retry hits the API again.
const treeCache = new Map();

export const fetchEnergyHierarchyTree = (username, start, end) => {
  const key = `${username}|${start}|${end}`;
  if (!treeCache.has(key)) {
    const request = api
      .get("/energy-hierarchy-tree", {
        params: { username, start, end },
        // The shared client times out at 60s by aborting the XHR, which Chrome
        // shows as (canceled). This call is one cached request per range.
        timeout: 0,
      })
      .then((res) => res.data)
      .catch((err) => {
        treeCache.delete(key);
        throw err;
      });
    treeCache.set(key, request);
  }
  return treeCache.get(key);
};

// Keep only nodes whose hierarchy_path is under the selected branch, so the
// chart roots at the branch instead of the whole facility. No branch = as is.
export const scopeHierarchyTree = (data, scopeHierarchyPath) => {
  if (!scopeHierarchyPath || !data || typeof data !== "object") return data;
  const scoped = {};
  Object.entries(data).forEach(([k, v]) => {
    if ((v?.hierarchy_path || "").startsWith(scopeHierarchyPath)) scoped[k] = v;
  });
  return scoped;
};
